<template>
  <div
    class="root-view">
    <router-view/>
  </div>
</template>

<script>
/**
 * 'MainView' Component
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
export default {
  name: 'RootView'
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .root-view {
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/views/root.view.vue